export default __webpack_public_path__ + "static/media/fire.78a375c0.svg";